module.exports = __webpack_public_path__ + "images/offers12c67ed354088e404ec0a7cf8184f66b.svg";